import React, { useContext } from 'react';
import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FincenContext } from './context';

export const ChangingYourOrderView = () => {
    return (
        <div className="border rounded-md p-5 shadow-md mb-5 border-error">
            <Title />
            <Content />
        </div>
    );
};

const Title = () => (
    <div className="text-error mb-2 font-semibold text-xl">
        <FontAwesomeIcon icon={faExclamationCircle} size="lg" className="mr-2" />
        Changing your order
    </div>
);

const Content = () => {
    const { enterInfoUrl, moreInfoUrl } = useContext(FincenContext);
    const sendToFincenForm = () => {
        if (enterInfoUrl) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).location.href = `${enterInfoUrl}?returnUrl=${window.location.href}`;
        }
    };

    return (
        <div className="font-semibold text-xs text-grey-2">
            <p>
                You have chosen not to supply the information required to complete your order. To
                proceed, you will have to remove items from your cart until, the total for your
                combined purchases for the past 24 hours is less than $10,000. You may still
                <button
                    className="underline text-brand mx-1 font-semibold"
                    onClick={sendToFincenForm}
                >
                    fill out the FinCEN form
                </button>
                if you choose to do so.
            </p>

            <p className="mt-5">
                For more information: <a href={moreInfoUrl}>RaiseRight FinCEN Policy</a>
            </p>
        </div>
    );
};
